import { IPlayerState } from '../reducer.types';
import { trackDuration } from '../actions';

const trackDurationReducer = (state: IPlayerState, action: ReturnType<typeof trackDuration>) => ({
  ...state,
  currentlyPlayingTrackDuration: action.payload.trackDuration,
});

export default trackDurationReducer;
